<template>
	<article class="resource resource-default">
		<ResourceHeroComponent :resource="resource" />

		<section class="band">
			<div class="main content">
				<div v-html="resource.post_content" />
			</div>
			<aside>
				<ResourceActionsComponent
					:resource="resource"
					:disable-print="true"
				/>
			</aside>
		</section>
	</article>
</template>

<script lang="ts">
import { type PropType, defineComponent } from 'vue';
import type { Resource } from '@/interfaces/resourceInterface';
import ResourceActionsComponent from '@/components/resources/ResourceActionsComponent.vue';
import ResourceHeroComponent from '@/components/resources/ResourceHeroComponent.vue';

export default defineComponent({
	components: { ResourceActionsComponent, ResourceHeroComponent },
	props: {
		resource: {
			type: Object as PropType<Resource>,
			required: true,
		},
	},
});
</script>

<style scoped lang="scss">
section {
	display: flex;
	flex-wrap: wrap;
	gap: 40px;

	.main {
		flex: 1;
		min-width: 300px;
		max-width: var(--rs-content-max-width);
	}

	aside {
		flex: 1;
		min-width: 300px;
	}
}
</style>
